<template>
  <footer class="text-center py-5">
    <div class="container px-5">
      <div class="text-white-50 small">
        <div class="mb-2">&copy; PokerMan {{ year }}. All Rights Reserved.</div>
        <a href="#" @click="handleJumpTo('privacyPolicy')">Privacy Policy</a>
        <span class="mx-1">&middot;</span>
        <a href="#" @click="handleJumpTo('termsService')">Terms of Service</a>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'FooterComp',
  data () {
    return {
      year: 2022
    }
  },
  mounted () {
    this.year = new Date().getFullYear() || 2022
  },
  methods: {
    handleJumpTo (name) {
      const { href } = this.$router.resolve({
        name: name
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/components/footer.vue